import React, { Component } from "react";
import { Button, Wrapper, Copy, Bold } from "app/NativeComponents/common";

class Tab extends Component {
  render() {
    const { is_active, onPress, title, colors } = this.props;
    if (this.props.is_active > 0) {
      if (this.props.disabled) {
        return (
          <Wrapper style={{ marginRight: 15 }}>
            <Wrapper
              style={{
                padding: 0,
                borderBottomWidth: 1,
                borderBottomColor: colors.active_color,
                borderBottomStyle: "solid"
              }}
            >
              <Copy style={{ color: colors.active_color }}>
                <Bold>{title}</Bold>
              </Copy>
            </Wrapper>
          </Wrapper>
        );
      }
      return (
        <Button onPress={onPress} style={{ marginRight: 15 }}>
          <Wrapper
            style={{
              padding: 0,
              borderBottomWidth: 1,
              borderBottomColor: colors.active_color,
              borderBottomStyle: "solid"
            }}
          >
            <Copy style={{ color: colors.active_color }}>
              <Bold>{title}</Bold>
            </Copy>
          </Wrapper>
        </Button>
      );
    }

    return (
      <Button onPress={onPress} style={{ marginRight: 15 }}>
        <Wrapper
          style={{
            padding: 0
          }}
        >
          <Copy>
            <Bold>{title}</Bold>
          </Copy>
        </Wrapper>
      </Button>
    );
  }
}

export default Tab;
